export const AUDIENCE = [
  {
    title: "Microimprese",
    desc: "Il supporto di un intero team di specialisti, senza gestire fornitori diversi per ogni esigenza.",
  },
  {
    title: "PMI",
    desc: "Competenze verticali su marketing, finanza e organizzazione per accompagnare la crescita della struttura.",
  },
  {
    title: "Privati",
    desc: "Consulenza legale, finanziaria e amministrativa per le scelte importanti della vita personale.",
  },
  {
    title: "Startup",
    desc: "Hai solo un'idea? Ti aiutiamo a strutturarla in un business vero: forma societaria, business plan, primi passi.",
  },
];

export const PERCHE_CARDS = [
  {
    n: "01",
    title: "11 aree di competenza",
    desc: "Tutto sotto lo stesso tetto, gestito da un solo team che le fa dialogare tra loro.",
  },
  {
    n: "02",
    title: "Operativo, non solo consulenziale",
    desc: "Non ci fermiamo al consiglio: eseguiamo, misuriamo, correggiamo.",
  },
  {
    n: "03",
    title: "8+ anni in settori diversi",
    desc: "Una visione ampia che si traduce in strategie su misura, per chi cresce e per chi parte da un'idea.",
  },
];
